<adapt-dashboard-element *adaptIfAlto="false"
                         name="Values"
                         [url]="vcUrl$ | async"
                         data-test="values-constitution-dashboard-element">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
</adapt-dashboard-element>

<adapt-styled-dashboard-element *adaptIfAlto="true"
                                name="Values"
                                [url]="vcUrl$ | async"
                                linkText="View values"
                                data-test="values-constitution-dashboard-element">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
</adapt-styled-dashboard-element>

<ng-template #content>
    @if (mode === "list") {
        <adapt-values-constitution-list-view [team]="team$ | async"></adapt-values-constitution-list-view>
    }
    @if (mode === "wide") {
        <adapt-values-constitution-wide-view></adapt-values-constitution-wide-view>
    }
</ng-template>
